import api from '../../../../utills/axiosConfig';

export const fetchSubCollections = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const { data } = await api.get('/sub-collections', { params });
  return data;
};

export const addSubCollection = async (subCollection) => {
  const { data } = await api.post('/sub-collections', subCollection);
  return data;
};

export const updateSubCollection = async (id, subCollection) => {
  const { data } = await api.put(`/sub-collections/${id}`, subCollection);
  return data;
};

export const deleteSubCollection = async (id) => {
  const { data } = await api.delete(`/sub-collections/${id}`);
  return data;
};

export const importSubCollectionCSV = async (formData) => {
  const { data } = await api.post('/sub-collections/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 